import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { SignUpComponent } from './sign-up/sign-up.component';
import { OrderDashboardComponent } from './order-dashboard/order-dashboard.component';
import { RateCardBasicComponent } from './rate-card-basic/rate-card-basic.component';
import { UserDetailsComponent } from './user-details/user-details.component';
import { EntityDetailsComponent } from './entity-details/entity-details.component';
import { VehiclesComponent } from './vehicles/vehicles.component';
import { VehiclesDashboardComponent } from './vehicles-dashboard/vehicles-dashboard.component';
import { DriversComponent } from './drivers/drivers.component';
import { AttendanceComponent } from './attendance/attendance.component';
import { ShipmentsDashboardComponent } from './shipments-dashboard/shipments-dashboard.component';
import { PostShipmentComponent } from './post-shipment/post-shipment.component';
import { BidOrderComponent } from './bid-order/bid-order.component';

import { OpenBidsComponent } from './open-bids/open-bids.component';
import { AttachDriverComponent } from './attach-driver/attach-driver.component';
import { AttachVehicleComponent } from './attach-vehicle/attach-vehicle.component';
import { DriverMapViewComponent } from './driver-map-view/driver-map-view.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { InvoicesComponent } from './invoices/invoices.component';
import { BillsComponent } from './bills/bills.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { CreateBillComponent } from './create-bill/create-bill.component';
import { ShipmentsMapComponent } from './shipments-map/shipments-map.component';
import { UnitSettingsComponent } from './unit-settings/unit-settings.component';
import { SpotOnDriverComponent } from './spot-on-driver/spot-on-driver.component';
import { TaxSettingsComponent } from './tax-settings/tax-settings.component';
import { MyShippersComponent } from './my-shippers/my-shippers.component';
import { SpotDriversComponent } from './spot-drivers/spot-drivers.component';
import { GanttDashboardComponent } from './gantt-dashboard/gantt-dashboard.component';
import { OverviewComponent } from './overview/overview.component';
import { DashboardSettingsComponent } from './dashboard-settings/dashboard-settings.component';
import { InvoicePreviewComponent } from './invoice-preview/invoice-preview.component';
import { AccountSettingsComponent } from './account-settings/account-settings.component';
import { PaymentVoucherComponent } from './payment-voucher/payment-voucher.component';
import { PaymentAdviceComponent } from './payment-advice/payment-advice.component';
import { RoleGuard } from './role.guard';
import { CreditNoteComponent } from './bills/credit-note/credit-note.component';
import { CreditNotesComponent } from './credit-notes/credit-notes.component';
import { DebitNotesComponent } from './debit-notes/debit-notes.component';
import { AttendanceSalaryComponent } from './attendance-salary/attendance-salary.component';
import { HelpDeskComponent } from './help-desk/help-desk.component';
import { CarrierScorecardComponent } from './carrier-scorecard/carrier-scorecard.component';
import { ReportsComponent } from './reports/reports.component';
import { RegisteredVehiclesComponent } from './registered-vehicles/registered-vehicles.component';
import { RegisteredDriversComponent } from './registered-drivers/registered-drivers.component';
import { AcknowlegdeComponent } from './acknowlegde/acknowlegde.component';
import { AuthGuard } from './services/auth.guard';
import { ExpressShipmentsDashboardComponent } from './express-shipments-dashboard/express-shipments-dashboard.component';
import { ExpressShipmentsComponent } from './express-shipments/express-shipments.component';
import { LoadDashboardComponent } from './load-dashboard/load-dashboard.component';
import { CementLoadDashboardComponent } from './cement-load-dashboard/cement-load-dashboard.component';
import { AssignLoadDashboardComponent } from './load-dashboard/assign-load-dashboard/assign-load-dashboard.component';
import { VehicleMapViewComponent } from './spot-drivers/vehicle-map-view/vehicle-map-view.component';
// import { DeletedShipmentsComponent } from './deleted-shipments/deleted-shipments.component';
import { OwnVehicleMapViewComponent } from './own-vehicle-map-view/own-vehicle-map-view.component';
import { ExternalParkingVehiclesComponent } from './external-parking-vehicles/external-parking-vehicles.component';
import { InPlantVehiclesComponent } from './in-plant-vehicles/in-plant-vehicles.component';
import { PartialRegistrationComponent } from './partial-registration/partial-registration.component';
import { PartialRegistrationDashboardComponent } from './partial-registration-dashboard/partial-registration-dashboard.component';
import { EnRouteVehiclesComponent } from './en-route-vehicles/en-route-vehicles.component';
import { VehiclesAtCustomersSiteComponent } from './vehicles-at-customers-site/vehicles-at-customers-site.component';
import { VehiclesUpdateStatusComponent } from './vehicles-update-status/vehicles-update-status.component';
import { ClosedTripsDetailsComponent } from './closed-trips-details/closed-trips-details.component';
import { ControlRoomComponent } from './control-room/control-room.component';
import { FreeLoadComponent } from './free-load/free-load.component';
import { EmailsSmsComponent } from './emails-sms/emails-sms.component';
import { ConsolidatedInvoiceComponent } from './consolidated-invoice/consolidated-invoice.component';
import { MwgDashboardComponent } from './mwg-dashboard/mwg-dashboard.component';
import { EpodsPrevComponent } from './epods-prev/epods-prev.component';
import { PdfViewerComponent } from './pdf-viewer/pdf-viewer.component';
import { LandingPageComponent } from './landing-page/landing-page.component';
import { RequestCallBackComponent } from './request-call-back/request-call-back.component';
import { LtlOrdersComponent } from './ltl-orders/ltl-orders.component';
import { OdcDashboardComponent } from './odc-dashboard/odc-dashboard.component';
import { NoZoneComponent } from './no-zone/no-zone';


const routes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  { path: 'login', component: LoginComponent },
  { path: 'signUp', component: SignUpComponent },
  { path: 'dashboard', component: OrderDashboardComponent },
  { path: 'dashboard/:mode/:type', component: OrderDashboardComponent },
  { path: 'dashboard/:flash', component: OrderDashboardComponent },
  { path: 'rateCard', component: RateCardBasicComponent },
  { path: 'user', component: UserDetailsComponent, canActivate: [RoleGuard], data: ['account_owner', 'user_administrator'] },
  { path: 'unit', component: EntityDetailsComponent, canActivate: [RoleGuard], data: ['account_owner', 'unit_administrator'] },
  { path: 'vehicles', component: VehiclesComponent, canActivate: [RoleGuard], data: ['account_owner', 'fleet_executive', 'fleet_administrator'] },
  { path: 'vehiclesDashboard', component: VehiclesDashboardComponent },
  { path: 'drivers', component: DriversComponent, canActivate: [RoleGuard], data: ['account_owner', 'fleet_executive', 'fleet_administrator'] },
  { path: 'attendance', component: AttendanceComponent },
  { path: 'shipmentsDashboard', component: ShipmentsDashboardComponent },
  { path: 'shipmentsDashboard/:type', component: ShipmentsDashboardComponent },
  { path: 'postShipment', component: PostShipmentComponent, canActivate: [RoleGuard], data: ['account_owner', 'shipment_executive', 'shipment_administrator'] },
  { path: 'bid-orders', component: BidOrderComponent },
  { path: 'driver-map-view', component: DriverMapViewComponent },
  { path: 'open-bids', component: OpenBidsComponent },
  { path: 'forgot', component: ForgotPasswordComponent },
  { path: 'attachVehicle', component: AttachVehicleComponent, canActivate: [RoleGuard], data: ['account_owner', 'fleet_executive', 'fleet_administrator'] },
  // { path: 'invoices', component: InvoicesComponent},
  { path: 'bills', component: BillsComponent, canActivate: [RoleGuard], data: ['account_owner', 'finance_executive', 'finance_administrator'] },
  { path: 'set_password', component: ResetPasswordComponent },
  { path: 'forgot_password', component: ResetPasswordComponent },
  { path: 'invoices', component: CreateBillComponent, canActivate: [RoleGuard], data: ['account_owner', 'finance_executive', 'finance_administrator'] },
  { path: 'shipment-map-view', component: ShipmentsMapComponent },
  { path: 'unitSettings', component: UnitSettingsComponent },
  { path: 'taxSettings', component: TaxSettingsComponent },
  { path: 'myShippers', component: MyShippersComponent, canActivate: [RoleGuard], data: ['account_owner', 'shipper_administrator'] },
  { path: 'gantt', component: GanttDashboardComponent },
  { path: 'spotDrivers', component: SpotDriversComponent, canActivate: [RoleGuard], data: ['account_owner', 'fleet_executive', 'fleet_administrator'] },
  { path: 'overview', component: OverviewComponent },
  { path: 'dashboardSettings', component: DashboardSettingsComponent },
  { path: 'payment-voucher', component: PaymentVoucherComponent, canActivate: [RoleGuard], data: ['account_owner', 'finance_executive', 'finance_administrator'] },
  { path: 'payment-advice', component: PaymentAdviceComponent, canActivate: [RoleGuard], data: ['account_owner', 'finance_executive', 'finance_administrator'] },
  // { path: 'deletedShipments', component: DeletedShipmentsComponent}
  { path: 'preview', component: InvoicePreviewComponent },
  // credit-notes
  { path: 'credit-notes', component: CreditNotesComponent, canActivate: [RoleGuard], data: ['account_owner', 'finance_executive', 'finance_administrator'] },
  { path: 'debit-notes', component: DebitNotesComponent, canActivate: [RoleGuard], data: ['account_owner', 'finance_executive', 'finance_administrator'] },
  { path: 'attendance-list', component: AttendanceSalaryComponent },
  { path: 'accountSettings', component: AccountSettingsComponent, canActivate: [RoleGuard], data: ['account_owner', 'finance_executive', 'finance_administrator'] },
  // temp

  { path: 'help-desk', component: HelpDeskComponent },
  { path: 'epods', component: EpodsPrevComponent },
  {
    path: 'registeredVehicles', component: RegisteredVehiclesComponent,
  },
  {
    path: 'registeredDrivers', component: RegisteredDriversComponent,
  },
  {
    path: 'expressDashboard', component: ExpressShipmentsDashboardComponent,
  },
  {
    path: 'expressShipments', component: ExpressShipmentsComponent,
  },
  {
    path: 'loadDashboard', component: LoadDashboardComponent,
  },
  {
    path: 'cementLoadDashboard', component: CementLoadDashboardComponent,
  },
  {
    path: 'loadDashboard/assign', component: AssignLoadDashboardComponent,
  },
  {
    path: 'freeLoadDashboard', component: FreeLoadComponent,
  },

  { path: "vehicle-map-view", component: VehicleMapViewComponent },
  { path: 'scorecard', component: CarrierScorecardComponent, canActivate: [RoleGuard], data: ['account_owner', 'shipment_executive', 'shipment_administrator'] },
  { path: 'reports', component: ReportsComponent },
  { path: 'ack/:type/:id', component: AcknowlegdeComponent, canActivate: [AuthGuard] },
  { path: "own-vehicle-map-view", component: OwnVehicleMapViewComponent },
  { path: 'externalParkingVehicles', component: ExternalParkingVehiclesComponent },
  { path: 'inPlantVehicles', component: InPlantVehiclesComponent },
  { path: 'partialRegistration', component: PartialRegistrationComponent },
  { path: 'partialRegistrationDashboard', component: PartialRegistrationDashboardComponent },  { path: 'inPlantVehicles', component: InPlantVehiclesComponent },
  { path: 'enRouteVehicles', component: EnRouteVehiclesComponent },
  { path: 'vehiclesAtCustomerSite', component: VehiclesAtCustomersSiteComponent },
  { path: 'vehiclesUpdateStatus', component: VehiclesUpdateStatusComponent },
  { path: 'closedTripsDetail', component: ClosedTripsDetailsComponent },
  { path: 'inTransitIdleVehicles', component: InPlantVehiclesComponent },
  { path: 'controlRoom', component: ControlRoomComponent },
  { path: 'emails', component: EmailsSmsComponent },
  { path: 'consolidatedInvoices', component: ConsolidatedInvoiceComponent },
  { path: 'mwgDashboard', component: MwgDashboardComponent },
  { path: 'pdfViewer', component: PdfViewerComponent },
  { path: 'welcome', component: LandingPageComponent },
  { path: 'requestCallBack', component: RequestCallBackComponent },
  { path: 'ltl-orders', component: LtlOrdersComponent },
  { path: 'odcDashboard', component: OdcDashboardComponent },
  { path: 'nozone', component: NoZoneComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
